import { Component, OnInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-types-of-mf',
  templateUrl: './types-of-mf.component.html',
  styleUrls: ['./types-of-mf.component.scss', './../ifacss.scss']
})
export class TypesOfMFComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
  modalPopOpen() {
    $('#LetsTalk_popup').modal('show');
  }
}
